// styles
import styles from './footer.module.scss'

type FooterProps = {
	readonly className?: string
}

const Footer = ({ className }: FooterProps): JSX.Element => {
	const footerLinks: ({
		readonly label: string
	} & React.AnchorHTMLAttributes<HTMLAnchorElement>)[] = [
		{ label: 'Terms of Use', href: '#' },
		{ label: 'User Terms of Use', href: '#' },
		{ label: 'Privacy Policy', href: '#' },
		{ label: 'Information Security Policy', href: '#' },
		{ label: 'Cookie Declaration', href: '#' },
	]
	return (
		<footer className={[styles.footer, className].join(' ').trim()}>
			<nav>
				<ul>
					{footerLinks.map((link, index) => {
						const { label, ...attr } = link
						return (
							<li key={index}>
								<a {...attr}>{link.label}</a>
							</li>
						)
					})}
				</ul>
			</nav>
			<p>
				Confidential and Proprietary Information of Talem Health
				Analytics Inc and Gradient AI. Patent Pending.
			</p>
			<p>© 2024 Talem Gradient Levio. All Rights Reserved</p>
		</footer>
	)
}
export default Footer
